export enum BudgetStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    CHANGED = 'CHANGED',
    COUNTER_PROPOSAL = 'COUNTER_PROPOSAL',
  }

export enum BudgetStatusFilterEnum {
  SENT = "Enviado",
  UPDATED = "Alterado",
  COUNTER_PROPOSED = "Contraproposta",
  APPROVED = "Aprovado",
  REJECTED = "Recusado",
}